__turbopack_context__.v({
  "editButton": "ProfileFieldListItem-module__6SNqGq__editButton",
  "item": "ProfileFieldListItem-module__6SNqGq__item",
  "label": "ProfileFieldListItem-module__6SNqGq__label",
  "root": "ProfileFieldListItem-module__6SNqGq__root",
  "value": "ProfileFieldListItem-module__6SNqGq__value",
});
